import useTransportsFetch from '@/app/components/hotel-detail/travel-api/transportsFetch';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { createPriceByDisplayType } from '@/app/components/search/utils/formatting.ts';

export default function useTransportSorting() {
  const { data: travelTransports } = useTransportsFetch();
  const { localization } = usePageWrapperData();
  const { priceIncrementDisplayType } = localization.configValuesApp;
  const filters = (travelTransports as FullAvailableTransportResponse)?.filters;

  const adaptOption = (option: SortFilterOption): TransportSortOption =>
    option === 'POPULAR' ? 'BERTOLI' : option === 'PRICE' ? 'PRICE_TRANSPORT' : 'FASTEST_TRANSPORT';

  const adaptFilterToSorting = (sortFilter: SortFilter[]): TransportSortingData[] =>
    sortFilter.map((sort) => ({
      sortOption: adaptOption(sort.option),
      priceIncrement: createPriceByDisplayType(sort.priceIncrement, priceIncrementDisplayType),
    }));

  return {
    data: adaptFilterToSorting(filters?.sortOptions || []),
  };
}
